const VERSION = '1.1.0';

export default VERSION;
